export const INGRESADA = 1;
export const EN_PROCESO = 2;
export const GENERACION_OFERTA = 3;
export const OFERTA_DISPONIBLE = 4;
export const OFERTA_NO_DISPONIBLE = 5;
export const OFERTA_EXPIRADA_POR_INACTIVIDAD = 6;
export const OFERTA_ACEPTADA = 7;
export const RETRACTO_OFERTA = 8;
export const CANCELADA = 9;
export const COMPLETADA = 10;
export const SOLICITUD = 11;
export const OFERTA_CANCELADA = 12;
export const OFERTA = 13;
export const ACEPTACION_OFERTA = 14;
export const ACEPTACION_PARCIAL = 11;

// /portabilidad/ofertas/{solicitudId}/pdf
